import "./logocustomization.css";
import {
  React,
  memo,
  Button,
  toast,
  useState,
  LoadingSpinner,
  Box,
  FileUploader,
  Switch,
  FormControlLabel,
  useUpdateCustomizationMutation,
  GetCookie,
  Divider,
  FormGroup,
  FormControl,
  FormLabel,
} from "../../../Libraries/Post/Customization/index";
import PropTypes from "prop-types"; // ES6

const fileTypes = ["PNG"];

const LogoCustomization = ({ AllCustomization, getCustomWidgets }) => {
  const [updatecustomization, { isLoading }] = useUpdateCustomizationMutation();

  const [data, setdata] = useState({
    checked: AllCustomization?.logo_status,
    logo_url: AllCustomization?.logo_url,
    file: null,
  });

  const handleChange = (event) => {
    setdata((previousvalue) => ({
      ...previousvalue,
      checked: event.target.checked,
    }));
  };

  const handleChangeLogo = async (file) => {
    setdata((previousvalue) => ({
      ...previousvalue,
      file: file,
      logo_url: URL.createObjectURL(file),
    }));
  };

  const handleSubmitLogo = async () => {
    const payloaddata = new FormData();
    payloaddata.append(
      "txt_customer_id",
      localStorage.getItem("txt_customer_id")
    );
    payloaddata.append("security_token", await GetCookie("es_token"));
    payloaddata.append("txt_customization_type", "Logo");
    payloaddata.append("logo_status", data.checked);
    if (data.file) {
      payloaddata.append("file", data.file);
    } else {
      payloaddata.append("logo_url", data.logo_url);
    }

    try {
      const res = await updatecustomization(payloaddata).unwrap();
      if (
        res.connection === "true" &&
        res.status === "true" &&
        res.message === "Logo information updated successfully"
      ) {
        getCustomWidgets();
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.status);
    }
  };

  return (
    <>
      {isLoading ? <LoadingSpinner /> : null}
      <Box paddingLeft={3} paddingRight={3}>
        <div className="row g-0">
          <div className="col col-sm-6 col-md-6 col-lg-6 d-flex justify-content-start mr-0 px-0">
            <span
              style={{ color: "black", fontWeight: "bold", fontSize: "25px" }}
            >
              Logo Customization
            </span>
          </div>
          <div className="col col-sm-6 col-md-6 col-lg-6 d-flex justify-content-end mr-0 px-0">
            <Button
              variant="contained"
              sx={{ maxHeight: "40px" }}
              onClick={handleSubmitLogo}
              className="capitalized fs-14 fw-bold"
            >
              Save & Post
            </Button>
          </div>
          <Divider />
        </div>
        <div className="row">
          <h3
            className="mt-4"
            style={{
              color: "black",
              fontWeight: "bold",
              fontSize: "20px",
              opacity: "87%",
            }}
          >
            Logo Styling
          </h3>
          <div className="col-md-6 col-lg-6 col-cl-6 col-sm-12">
            <div className="logocustomization">
              <FileUploader
                handleChange={handleChangeLogo}
                name="file"
                types={fileTypes}
              />
            </div>
            <p className="mt-1">152 * 152 Size JPG or PNG is recommended</p>
          </div>

          <div className="col-md-6 col-lg-6 col-cl-6 col-sm-12">
            <div className="logoview d-flex justify-content-center">
              {data?.logo_url && (
                <img
                  alt="logo"
                  src={data?.logo_url}
                  width="152px"
                  height="152px"
                  style={{ objectFit: "contain" }}
                />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <FormControl component="fieldset" className="mt-3">
              <FormLabel component="legend">Logo Status</FormLabel>
              <FormGroup aria-label="position" row>
                <FormControlLabel
                  sx={{ marginLeft: "0px" }}
                  value="start"
                  control={<Switch color="primary" />}
                  label="Show Image"
                  labelPlacement="start"
                  onChange={handleChange}
                  checked={data?.checked}
                />
              </FormGroup>
            </FormControl>
          </div>
        </div>
      </Box>
    </>
  );
};

LogoCustomization.propTypes = {
  AllCustomization: PropTypes.object,
  getCustomWidgets: PropTypes.func,
};

export default memo(LogoCustomization);
